import { Component, Input } from '@angular/core';
import {
  BoelsBannerMediaTeaser,
  CmsComponentData,
  ImageLoadingStrategy,
} from '@boels/models';

import { AsyncPipe } from '@angular/common';
import { MediaComponent } from '../../media/media.component';

@Component({
  imports: [MediaComponent, AsyncPipe],
  selector: 'boels-simple-banner',
  templateUrl: './simple-banner.component.html',
  styleUrls: ['./simple-banner.component.scss'],
})
export class SimpleBannerComponent {
  @Input() componentData: CmsComponentData<BoelsBannerMediaTeaser>;
  public ImageLoadingStrategy = ImageLoadingStrategy;
}
